import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import PageHeader from '../../../components/Layout/PageHeader.jsx';
import ChoferForm from '../../../components/ChoferForm.jsx';
import { useChoferMutations } from '../../../hooks/useChoferes.js';
import { uploadChoferDocuments } from '../../../services/choferDocumentos.js';

export default function CrearChofer() {
  const navigate = useNavigate();
  const { create } = useChoferMutations();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const persistChofer = async values => {
    const input = {
      ...values,
      licenciaClase: values.licenciaClase,
      aptoPsicofisico: Boolean(values.aptoPsicofisico),
      docOtros: values.docOtros?.filter(Boolean) ?? [],
    };
    delete input.__documentFiles;
    const chofer = await create(input);
    await uploadChoferDocuments(chofer?.id, values.__documentFiles);
    return chofer;
  };

  const handleSubmit = async values => {
    setSaving(true);
    setError(null);
    try {
      await persistChofer(values);
      await Swal.fire('Chofer creado', 'El chofer se registró correctamente.', 'success');
      navigate('/administracion/choferes');
    } catch (mutationError) {
      setError(mutationError.message);
    } finally {
      setSaving(false);
    }
  };

  const handleSaveAndNew = async values => {
    setSaving(true);
    setError(null);
    try {
      await persistChofer(values);
      await Swal.fire('Chofer creado', 'Podés cargar otro chofer ahora.', 'success');
      setSaving(false);
      return true;
    } catch (mutationError) {
      setError(mutationError.message);
      setSaving(false);
      return false;
    }
  };

  return (
    <div className="mx-auto max-w-[1400px] space-y-6 px-4 pb-24">
      <PageHeader
        title="Nuevo chofer"
        subtitle="Cargá un nuevo chofer con validaciones operativas, sucursal activa y documentación real."
        breadcrumbs={[
          { label: 'Administración', href: '/administracion' },
          { label: 'Choferes', href: '/administracion/choferes' },
          { label: 'Nuevo' },
        ]}
      />

      {error ? (
        <div className="rounded-2xl border border-red-200 bg-red-50 px-6 py-4 text-sm text-red-700 dark:border-red-900/60 dark:bg-red-950/40 dark:text-red-200">
          <p className="font-semibold">No pudimos guardar el chofer.</p>
          <p className="mt-1 text-xs opacity-90">{error}</p>
        </div>
      ) : null}

      <ChoferForm
        onSubmit={handleSubmit}
        onCancel={() => navigate('/administracion/choferes')}
        saving={saving}
        showSaveAndNew
        onSaveAndNew={handleSaveAndNew}
      />
    </div>
  );
}
